export function generateError(msg) {
    return `[𖣠] Launched error: ${msg}`;
}
export default function error(msg) {
    throw new Error(generateError(msg));
}
